import { authApi } from '../api/client';

export const NotificationService = {
    async init(navigate) {
        console.log('[NativeBridge] Initializing bridge listeners...');

        // Callback for native notification click intent routing
        window.onNotificationClicked = (path) => {
            console.log('[NativeBridge] Notification clicked, routing path:', path);
            if (path) {
                navigate(path);
            }
        };
    },

    async registerDeviceToken() {
        if (typeof window.ShopAxoBridge === 'undefined') {
            console.warn('[NativeBridge] ShopAxoBridge not found');
            return;
        }

        try {
            console.log('[NativeBridge] Bridge Available - retrieving FCM token and Device ID...');
            const token = window.ShopAxoBridge.getFcmToken();
            const deviceId = window.ShopAxoBridge.getDeviceId();
            const deviceName = window.ShopAxoBridge.getDeviceName ? window.ShopAxoBridge.getDeviceName() : 'Android Device';
            const platform = window.ShopAxoBridge.getPlatform ? window.ShopAxoBridge.getPlatform() : 'Android';
            const appVersion = window.ShopAxoBridge.getAppVersion ? window.ShopAxoBridge.getAppVersion() : '1.0.0';

            console.log('[NativeBridge] Retrieved FCM Token:', token ? `YES (Length: ${token.length})` : 'NO');
            console.log('[NativeBridge] Retrieved Device ID:', deviceId);

            if (token && deviceId) {
                console.log('[NativeBridge] Uploading Device... DeviceId:', deviceId);
                const res = await authApi.registerDevice({
                    deviceId,
                    deviceName,
                    platform,
                    fcmToken: token,
                    appVersion
                });
                if (res.data?.success) {
                    console.log('[NativeBridge] Upload Success');
                } else {
                    console.warn('[NativeBridge] Upload Failed:', res.data?.message);
                }
            } else {
                console.warn('[NativeBridge] Upload Failed: missing token or deviceId');
            }
        } catch (err) {
            console.error('[NativeBridge] Upload Failed:', err);
        }
    },

    async unregister() {
        if (typeof window.ShopAxoBridge === 'undefined') return;
        try {
            const deviceId = window.ShopAxoBridge.getDeviceId();
            if (deviceId) {
                await authApi.unregisterDevice({ deviceId });
                console.log('[NativeBridge] Successfully unregistered device token on backend');
            }
        } catch (e) {
            console.error('[NativeBridge] Failed to unregister device:', e);
        }
    }
};
